import { useMemo } from 'react'
import { resolveActivationMotionConfig } from './activationViewModel.motion'
import { resolveActivationValidationModel } from './activationViewModel.validation'
import { resolveActivationViewCopy } from './activationViewModel.copy'
import type { UseActivationViewModelInput, UseActivationViewModelOutput } from './activationViewModel.types'

export const useActivationViewModel = ({
  state,
  t,
  prefersReducedMotion,
}: UseActivationViewModelInput): UseActivationViewModelOutput => {
  const validation = useMemo(
    () =>
      resolveActivationValidationModel({
        state,
        t,
      }),
    [state, t],
  )

  const motion = useMemo(
    () => resolveActivationMotionConfig(prefersReducedMotion),
    [prefersReducedMotion],
  )

  const copy = useMemo(() => resolveActivationViewCopy(t), [t])

  return {
    ...validation,
    motion,
    copy,
  }
}
